import styles from './ServicePlanRow.module.scss';

import { EhrPlanData, LegalEntityData } from 'chaika-frontend-types/frontend-cms';

import { Text } from '@components/Text';
import { TextModifiers } from '@components/Text/Text';
import { translate } from '@chaika/i18n/helper';
import { TelLink } from '@components/TelLink';
import { removeNotNumbers } from '@utils/removeNotNumbers';
import { EmailLink } from '@components/EmailLink';

interface Props {
    servicePlan: EhrPlanData;
    legalEntityMap: Map<string, LegalEntityData>;
    isFetched: boolean;
}

export const ServicePlanRow = ({ servicePlan, legalEntityMap, isFetched }: Props) => {
    const legalEntityInfo = servicePlan.payerId ? legalEntityMap.get(servicePlan.payerId) : undefined;

    const notSpecified = !!servicePlan.payerId && !isFetched ? '' : translate('notSpecified');

    const phone = legalEntityInfo?.phone;
    const emails = legalEntityInfo?.emails ?? [];
    const emailsNegotiation = legalEntityInfo?.emailsNegotiation ?? [];

    return (
        <div className={styles.root}>
            <Text
                modifiers={[TextModifiers.SmallText]}
                title={translate('viewSecond')}
                text={servicePlan.name}
            />
            <div className={styles.noWrap}>
                <Text
                    modifiers={phone ? [TextModifiers.SmallText] : [TextModifiers.GreyText, TextModifiers.SmallText]}
                    title={translate('phone')}
                    text={phone ? <TelLink tel={`+${removeNotNumbers(phone)}`} /> : notSpecified}
                />
            </div>
            <div className={styles.noWrap}>
                <Text
                    title={translate('mail')}
                    modifiers={
                        emails.length > 0
                            ? [TextModifiers.SmallText]
                            : [TextModifiers.GreyText, TextModifiers.SmallText]
                    }
                    text={emailsNegotiation.length > 0 ? <EmailLink email={emailsNegotiation[0]} /> : notSpecified}
                />
            </div>
        </div>
    );
};
